import { iconsAndImages } from "../../assets/images";
import footerJson from "./footer.json";
import "./style.scss";

export const Footer = () => {
    return (
        <section className="footer-section py-5">
            <div className="container">
                <div className="row gy-4 align-items-start">
                    <div className="col-12 col-lg-6 text-light">
                        <div className="d-flex align-items-center gap-3">
                            <img alt="" width={"70"} src={iconsAndImages[footerJson?.footerLogo]} />
                            <h3>{footerJson?.footerTitle}</h3>
                        </div>
                        <p
                            className="py-3 footer-desc"
                            dangerouslySetInnerHTML={{
                                __html: footerJson?.footerSubContent,
                            }}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="row text-light justify-content-lg-end">
                            <div className="col-6 col-sm-6 col-lg-auto">
                                <h5>{footerJson?.contentList?.firstList?.title}</h5>
                                <ul className="list-unstyled py-3 footer-list">
                                    {footerJson?.contentList?.firstList?.links?.map((link, index) => (
                                        <li key={index}>{link}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="col-6 col-sm-6 col-lg-auto">
                                <h5>{footerJson?.contentList?.secondList?.title}</h5>
                                <ul className="list-unstyled py-3 footer-list">
                                    {footerJson?.contentList?.secondList?.links?.map((link, index) => (
                                        <li key={index}>{link}</li>
                                    ))}
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>

                <hr className="footer-divider" />

                <div className="row gy-3 align-items-center">
                    <div className="col-12 col-md-6 text-light text-center text-md-start">
                        <p className="mb-0">{footerJson?.btmFootLeftContent}</p>
                    </div>
                    <div className="col-12 col-md-6 d-flex flex-wrap gap-3 justify-content-center justify-content-md-end">
                        {footerJson?.btmFootRightContent?.map((details, index) => (
                            <p key={index} className="text-light mb-0">
                                {details}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
